export default __webpack_public_path__ + "static/media/successful-medical-team (1).f3483214.jpg";